import React from "react";

import Spin from "../assets/images/b_loading-alpha (1).gif";

function Spiner() {
  return <img src={Spin} alt="Spin" style={{ width: "300px" }} />;
}

export default Spiner;
